 import React from 'react'
import './Item.css'
import { Link } from 'react-router-dom'

const Item = ({ id, image, name, new_price, old_price }) => {
  return (
    <div className="item">
      <Link to={`/product/${id}`}>
        <img onClick={window.scrollTo(0,0)} src={image} alt={name} />
      </Link>

      <p>{name}</p>

      <div className="item-prices">
        <span className="item-price-new">₹{new_price}</span>
        <span className="item-price-old">₹{old_price}</span>
      </div>
    </div>
  )
}

export default Item
